import Cookies from 'js-cookie';

export default class Header {
    constructor() {
        this.body = document.querySelector('body');
        this.header = document.querySelector('header');

        this.btnOpenMenu = this.header.querySelector('.btnOpenMenu');
        this.btnOpenAccessibility = this.header.querySelector('.btnOpenAccessibility');

        this.menu = this.header.querySelector('.menu');
        this.menuAccessibility = this.header.querySelector('.acessibilityBar');
        this.sectionNavList = this.header.querySelector('.sectionNavList');

        this.handleCookie();
        this.setActiveNavItem();
        this.handleMenuVisibility();

        this.searchModal();
        this.businessNavSelect();

        if (this.btnOpenMenu && this.menu) {
            this.actionMenu();
        }

        this.actionAccessibility();

        this.actionGoToTop();
        this.actionGoToMainContent();
        this.handleFocusOutSubmenus();
        this.handleZoomedLayout();
        this.setupSubmenuFilters();
    }

    handleMenuVisibility() {
        const currentPath = window.location.pathname;
        const cookieValue = Cookies.get('raizenlubslocal');

        const menuB2B = document.querySelector('#menu_b2b');
        const menuB2C = document.querySelector('#menu_b2c');
        const menuTools = document.querySelector('#menu_tools');

        // Se estiver na home, não faz nada (menus ficam hidden)
        if (currentPath === '/') {
            return;
        }

        // Se a URL contém para-empresas, para-revendas-e-consumidores ou ferramentas-e-solucoes-digitais
        // mostra o menu correspondente
        if (currentPath.includes('/para-empresas')) {
            menuB2B.classList.remove('!hidden');
            return;
        }

        if (currentPath.includes('/para-revendas-e-consumidores')) {
            menuB2C.classList.remove('!hidden');
            return;
        }

        if (currentPath.includes('/ferramentas-e-solucoes-digitais')) {
            menuTools.classList.remove('!hidden');
            return;
        }

        // Se não é home e não tem os paths específicos, mostra o menu baseado no cookie
        if (cookieValue === 'para-empresas' && menuB2B) {
            menuB2B.classList.remove('!hidden');
        } else if (cookieValue === 'para-revendas-e-consumidores' && menuB2C) {
            menuB2C.classList.remove('!hidden');
        } else if (cookieValue === 'ferramentas-e-solucoes-digitais') {
            // Se veio de ferramentas e está em uma página genérica, mostra B2B por padrão
            if (menuB2B) {
                menuB2B.classList.remove('!hidden');
            }
        }
    }

    handleCookie() {
        const allowedPaths = ['para-empresas', 'para-revendas-e-consumidores', 'ferramentas-e-solucoes-digitais'];
        const currentPath = window.location.pathname.split('/').filter(Boolean)[0];

        if (!Cookies.get('raizenlubslocal')) {
            Cookies.set('raizenlubslocal', 'para-empresas', { expires: 30 });
        } else {
            if (allowedPaths.includes(currentPath)) {
                Cookies.set('raizenlubslocal', currentPath, { expires: 30 });
            }
        }
    }

    setActiveNavItem() {
        const currentUrl = window.location.href;
        const currentPath = window.location.pathname;
        const cookieValue = Cookies.get('raizenlubslocal');

        this.sectionNavList.querySelectorAll('a').forEach((link) => {
            const linkUrl = link.href;
            const linkPath = new URL(linkUrl).pathname;

            // Remove todas as classes active primeiro
            link.classList.remove('active');

            // Verifica se é a home page - tem prioridade máxima
            if (currentPath === '/' && linkPath === '/') {
                link.classList.add('active');
            }
            // Se não for home, usa o cookie
            else if (currentPath !== '/') {
                // Verifica se está exatamente na página da seção (match exato do path)
                if (linkPath !== '/' && currentPath === linkPath) {
                    link.classList.add('active');
                }
                // Se não estiver na URL específica, usa o cookie
                else if (cookieValue === 'para-empresas' && linkUrl.includes('para-empresas')) {
                    link.classList.add('active');
                } else if (
                    cookieValue === 'para-revendas-e-consumidores' &&
                    linkUrl.includes('para-revendas-e-consumidores')
                ) {
                    link.classList.add('active');
                } else if (
                    cookieValue === 'ferramentas-e-solucoes-digitais' &&
                    linkUrl.includes('ferramentas-e-solucoes-digitais')
                ) {
                    link.classList.add('active');
                }
            }
        });

        // Adiciona listeners para atualizar o cookie ao clicar nos links do desktop
        this.sectionNavList.querySelectorAll('a').forEach((link) => {
            link.addEventListener('click', () => {
                const linkUrl = link.href;
                if (linkUrl.includes('para-empresas')) {
                    Cookies.set('raizenlubslocal', 'para-empresas', { expires: 30 });
                } else if (linkUrl.includes('para-revendas-e-consumidores')) {
                    Cookies.set('raizenlubslocal', 'para-revendas-e-consumidores', { expires: 30 });
                } else if (linkUrl.includes('ferramentas-e-solucoes-digitais')) {
                    Cookies.set('raizenlubslocal', 'ferramentas-e-solucoes-digitais', { expires: 30 });
                }
            });
        });
    }

    actionMenu() {
        this.btnOpenMenu.addEventListener('click', () => {
            this.btnOpenAccessibility.classList.remove('active');
            this.menuAccessibility.classList.remove('active');
            this.btnOpenMenu.classList.toggle('active');
            this.menu.classList.toggle('active');

            const isExpanded = this.menu.classList.contains('active');
            this.btnOpenMenu.setAttribute('aria-expanded', isExpanded);

            this.body.style.overflow = this.menu.classList.contains('active') ? 'hidden' : 'auto';
        });

        this.menu.querySelectorAll('.hasSubMenu').forEach((item) => {
            const button = item.querySelector('button');

            const toggleSubmenu = (e) => {
                e.preventDefault();
                e.stopPropagation();

                const submenu = item.nextElementSibling;
                const isExpanded = button.getAttribute('aria-expanded') === 'true';

                this.menu.querySelectorAll('.hasSubMenu').forEach((subItem) => {
                    if (subItem !== item) {
                        subItem.classList.remove('active');
                        subItem.nextElementSibling.classList.remove('active');
                        subItem.querySelector('button').setAttribute('aria-expanded', false);
                        this.body.style.overflow = 'auto';
                    }
                });

                if (!isExpanded) {
                    item.classList.add('active');
                    submenu.classList.add('active');
                    button.setAttribute('aria-expanded', true);
                    this.body.style.overflow = 'hidden';
                } else {
                    item.classList.remove('active');
                    submenu.classList.remove('active');
                    button.setAttribute('aria-expanded', false);
                }
            };

            button.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    toggleSubmenu(e);
                }
            });

            button.addEventListener('click', toggleSubmenu);
        });
    }

    overlay() {
        this.header.addEventListener('mouseenter', () => {
            this.overlayHeader.classList.remove('invisible');
            this.overlayHeader.classList.remove('opacity-0');
        });
        this.header.addEventListener('mouseleave', () => {
            this.overlayHeader.classList.add('invisible');
            this.overlayHeader.classList.add('opacity-0');
        });
    }

    searchModal() {
        const btnActionSearchModal = document.querySelectorAll('.btnActionSearch');
        const modalSearch = document.querySelector('.modal-busca');

        btnActionSearchModal.forEach((el) => {
            el.addEventListener('click', () => {
                modalSearch.classList.toggle('active');

                const isActive = modalSearch.classList.contains('active');
                if (isActive) {
                    modalSearch.removeAttribute('aria-hidden');
                    modalSearch.removeAttribute('inert');
                } else {
                    modalSearch.setAttribute('aria-hidden', 'true');
                    modalSearch.setAttribute('inert', '');
                }
            });
        });
    }

    actionAccessibility() {
        this.btnOpenAccessibility.addEventListener('click', () => {
            this.menu.classList.remove('active');
            this.btnOpenMenu.classList.remove('active');
            this.btnOpenAccessibility.classList.toggle('active');
            this.menuAccessibility.classList.toggle('active');

            const isExpanded = this.menuAccessibility.classList.contains('active');
            this.btnOpenAccessibility.setAttribute('aria-expanded', isExpanded);
        });
    }

    actionGoToTop() {
        const btnGoToTop = document.querySelector('.btnGoToTop');

        if (btnGoToTop) {
            btnGoToTop.addEventListener('click', () => {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth',
                });
            });
        }
    }

    actionGoToMainContent() {
        const btnGoToMainContent = document.querySelector('#btnScrollMainContent');
        if (btnGoToMainContent) {
            btnGoToMainContent.addEventListener('click', (e) => {
                const firstSection = document.querySelector('body section');
                if (firstSection) {
                    firstSection.scrollIntoView({ behavior: 'smooth' });
                }
            });
        }
    }

    handleFocusOutSubmenus() {
        if (!this.menu) return;

        document.addEventListener('focusin', (e) => {
            const activeSubmenus = this.menu.querySelectorAll('.hasSubMenu.active');

            activeSubmenus.forEach((item) => {
                const submenu = item.nextElementSibling;
                const isInCurrent = item.contains(e.target) || submenu?.contains(e.target);

                if (!isInCurrent) {
                    item.classList.remove('active');
                    submenu?.classList.remove('active');
                    item.querySelector('button')?.setAttribute('aria-expanded', false);
                }
            });
        });
    }

    handleZoomedLayout() {
        const checkLayoutConditions = () => {
            const screenWidth = window.innerWidth;
            const zoomLevel = Math.round((window.outerWidth / window.innerWidth) * 100);

            const needsLayoutChanges = screenWidth <= 1280 && zoomLevel > 110;

            this.body.classList.toggle('zoomed', needsLayoutChanges);

            const menuSubContainer = this.header.querySelector('#menuSubContainer');
            if (menuSubContainer) {
                menuSubContainer.classList.toggle('py-4', needsLayoutChanges);
                menuSubContainer.classList.toggle('lg:py-0', needsLayoutChanges);
            }
        };

        checkLayoutConditions();

        window.addEventListener('resize', checkLayoutConditions);
    }

    businessNavSelect() {
        const btnBusinessNavSelect = this.header.querySelector('.btnBusinessNavSelect');
        if (!btnBusinessNavSelect) return;

        const btnToggle = btnBusinessNavSelect.querySelector('button');
        const optionsContainer = btnBusinessNavSelect.querySelector('.businessNavOptions');
        const options = btnBusinessNavSelect.querySelectorAll('.businessNavOption');
        const selectedLabel = btnBusinessNavSelect.querySelector('.businessNavSelectedLabel');
        const changeProfileSpan = btnBusinessNavSelect.querySelector('.businessNavChangeProfile');
        const chevron = btnBusinessNavSelect.querySelector('.businessNavChevron');
        const currentUrl = window.location.href;
        const currentPath = window.location.pathname;
        const cookieValue = Cookies.get('raizenlubslocal');

        let activeOptionLabel = '';

        // Define a opção ativa inicialmente baseado na URL ou no cookie
        let initialSet = false;
        let activeOption = null;

        options.forEach((option) => {
            const linkUrl = option.href;
            const linkPath = new URL(linkUrl).pathname;

            // Remove background ativo de todos primeiro
            option.classList.remove('bg-neutral150', 'dark:bg-neutral100');

            // Prioriza a URL atual - se estiver na home, mostra Home
            if (currentPath === '/' && linkPath === '/') {
                activeOptionLabel = option.dataset.label;
                activeOption = option;
                initialSet = true;
            }
            // Se estiver exatamente na página da seção (match exato do path)
            else if (linkPath !== '/' && currentPath === linkPath) {
                activeOptionLabel = option.dataset.label;
                activeOption = option;
                initialSet = true;
            }
        });

        // Se não encontrou pela URL, usa o cookie como fallback
        if (!initialSet) {
            options.forEach((option) => {
                const linkUrl = option.href;
                if (cookieValue === 'para-empresas' && linkUrl.includes('para-empresas')) {
                    activeOptionLabel = option.dataset.label;
                    activeOption = option;
                    initialSet = true;
                } else if (
                    cookieValue === 'para-revendas-e-consumidores' &&
                    linkUrl.includes('para-revendas-e-consumidores')
                ) {
                    activeOptionLabel = option.dataset.label;
                    activeOption = option;
                    initialSet = true;
                } else if (
                    cookieValue === 'ferramentas-e-solucoes-digitais' &&
                    linkUrl.includes('ferramentas-e-solucoes-digitais')
                ) {
                    activeOptionLabel = option.dataset.label;
                    activeOption = option;
                    initialSet = true;
                }
            });
        }

        // Define o texto inicial
        selectedLabel.textContent = activeOptionLabel;

        // Adiciona background cinza no item ativo
        if (activeOption) {
            activeOption.classList.add('bg-neutral150', 'dark:bg-neutral100');
        }

        // Ao clicar em uma opção, atualiza o cookie
        options.forEach((option) => {
            option.addEventListener('click', () => {
                const linkUrl = option.href;
                if (linkUrl.includes('para-empresas')) {
                    Cookies.set('raizenlubslocal', 'para-empresas', { expires: 30 });
                } else if (linkUrl.includes('para-revendas-e-consumidores')) {
                    Cookies.set('raizenlubslocal', 'para-revendas-e-consumidores', { expires: 30 });
                } else if (linkUrl.includes('ferramentas-e-solucoes-digitais')) {
                    Cookies.set('raizenlubslocal', 'ferramentas-e-solucoes-digitais', { expires: 30 });
                }
            });
        });

        // Toggle do dropdown
        const toggleDropdown = (shouldOpen) => {
            const isExpanded = btnToggle.getAttribute('aria-expanded') === 'true';
            const willOpen = shouldOpen !== undefined ? shouldOpen : !isExpanded;

            if (willOpen) {
                // Abrindo: muda para "Selecione o perfil:" e esconde "Mudar perfil"
                selectedLabel.textContent = 'Selecione o perfil:';
                changeProfileSpan.classList.add('hidden');
                btnToggle.setAttribute('aria-expanded', 'true');
                optionsContainer.classList.remove('hidden');
                chevron.classList.add('rotate-180');
                // Foca no primeiro item
                options[0]?.focus();
            } else {
                // Fechando: volta para o item ativo e mostra "Mudar perfil"
                selectedLabel.textContent = activeOptionLabel;
                changeProfileSpan.classList.remove('hidden');
                btnToggle.setAttribute('aria-expanded', 'false');
                optionsContainer.classList.add('hidden');
                chevron.classList.remove('rotate-180');
            }
        };

        btnToggle.addEventListener('click', (e) => {
            e.stopPropagation();
            toggleDropdown();
        });

        // Navegação por teclado no botão
        btnToggle.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                e.stopPropagation();
                toggleDropdown();
            } else if (e.key === 'Escape') {
                const isExpanded = btnToggle.getAttribute('aria-expanded') === 'true';
                if (isExpanded) {
                    e.preventDefault();
                    toggleDropdown(false);
                    btnToggle.focus();
                }
            }
        });

        // Navegação por teclado nas opções
        options.forEach((option, index) => {
            option.addEventListener('keydown', (e) => {
                if (e.key === 'Escape') {
                    e.preventDefault();
                    toggleDropdown(false);
                    btnToggle.focus();
                } else if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    const nextOption = options[index + 1] || options[0];
                    nextOption.focus();
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    const prevOption = options[index - 1] || options[options.length - 1];
                    prevOption.focus();
                } else if (e.key === 'Tab' && e.shiftKey && index === 0) {
                    // Shift+Tab no primeiro item - fecha e volta pro botão
                    toggleDropdown(false);
                } else if (e.key === 'Tab' && !e.shiftKey && index === options.length - 1) {
                    // Tab no último item - fecha
                    toggleDropdown(false);
                }
            });
        });

        // Fecha ao clicar fora
        document.addEventListener('click', (e) => {
            if (!btnBusinessNavSelect.contains(e.target)) {
                const isExpanded = btnToggle.getAttribute('aria-expanded') === 'true';
                if (isExpanded) {
                    btnToggle.setAttribute('aria-expanded', 'false');
                    optionsContainer.classList.add('hidden');
                    chevron.classList.remove('rotate-180');
                    // Volta para o item ativo e mostra "Mudar perfil"
                    selectedLabel.textContent = activeOptionLabel;
                    changeProfileSpan.classList.remove('hidden');
                }
            }
        });

        // Fecha ao pressionar ESC
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && !optionsContainer.classList.contains('hidden')) {
                btnToggle.setAttribute('aria-expanded', 'false');
                optionsContainer.classList.add('hidden');
                chevron.classList.remove('rotate-180');
                btnToggle.focus();
                // Volta para o item ativo e mostra "Mudar perfil"
                selectedLabel.textContent = activeOptionLabel;
                changeProfileSpan.classList.remove('hidden');
            }
        });
    }

    setupSubmenuFilters() {
        if (!this.menu) return;

        // Para cada submenu que tenha filtros
        const submenus = this.menu.querySelectorAll('.submenu');

        submenus.forEach((submenu) => {
            const filterButtons = submenu.querySelectorAll('.filter-btn');
            const thirdmenuItems = submenu.querySelectorAll('.thirdmenu-item');

            if (filterButtons.length === 0) return;

            // Ativa o primeiro botão e aplica o filtro inicialmente
            if (filterButtons.length > 0) {
                const firstFilter = filterButtons[0].dataset.filter;
                filterButtons[0].classList.add('active');
                filterButtons[0].setAttribute('aria-pressed', 'true');
                this.applySubmenuFilter(thirdmenuItems, firstFilter);
            }

            // Adiciona event listeners nos botões de filtro
            filterButtons.forEach((button) => {
                button.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    const filter = button.dataset.filter;

                    // Remove active de todos os botões deste submenu
                    filterButtons.forEach((btn) => {
                        btn.classList.remove('active');
                        btn.setAttribute('aria-pressed', 'false');
                    });

                    // Adiciona active no botão clicado
                    button.classList.add('active');
                    button.setAttribute('aria-pressed', 'true');

                    // Aplica o filtro
                    this.applySubmenuFilter(thirdmenuItems, filter);
                });
            });
        });
    }

    applySubmenuFilter(items, filter) {
        items.forEach((item) => {
            const itemBusiness = item.dataset.business;

            if (!filter || filter === 'all' || itemBusiness === filter) {
                item.style.display = '';
                item.classList.remove('hidden');
            } else {
                item.style.display = 'none';
                item.classList.add('hidden');
            }
        });
    }
}

new Header();
